// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__1J697","footer":"ModalCreateQualiphyProcedure_footer__2A2ne","additionData":"ModalCreateQualiphyProcedure_additionData__2j026"};